export interface AddEventListenerOptions {
	once?: boolean;
}

export class EventListener {
	private eventListeners: Record<string, ((payload?: any) => void)[]> = {};

	public addListener(
		event: string,
		callback: (payload?: any) => void,
		options?: AddEventListenerOptions,
	) {
		if (!this.eventListeners[event]) this.eventListeners[event] = [];

		const { once = false } = options || {};
		const listener = once
			? (payload?: any) => {
					callback(payload);
					this.removeListener(event, listener);
			  }
			: callback;
		this.eventListeners[event].push(listener);
		return () => this.removeListener(event, listener);
	}

	public removeListener(event: string, callback: (event: Event) => void) {
		if (!this.eventListeners[event] || !this.eventListeners[event].length) return;

		this.eventListeners[event] = this.eventListeners[event].filter(
			(listener) => listener !== callback,
		);
	}

	public dispatchEvent(event: string, payload?: any) {
		if (!this.eventListeners[event] || !this.eventListeners[event].length) return;
		this.eventListeners[event].forEach((listener) => listener(payload));
	}
}
